// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum SpOperationalState {
  All = 'All',
  TotalDown = 'TotalDown',
  PartiallyDown = 'PartiallyDown',
  NoImpact = 'NoImpact',
}

export enum SpTicketType {
  All = 'All',
  ServiceTicket = 'ServiceTicket',
  Maintenance = 'Maintenance',
  Update = 'Update',
}

export enum SpTicketStatus {
  All = 'All',
  Closed = 'Closed',
  Open = 'Open',
}

export enum SpPartStatus {
  All = 'All',
  Consumed = 'Consumed',
  Ordered = 'Ordered',
}

export enum SpOperationalStateColor {
  Red = 'red',
  Green = 'green',
  Yellow = 'yellow',
  Grey = 'grey',
}
